import Box from "./Box";
import React from "react";

function BuyWearReturnRepeatAlt() {
  return (
    <Box
      position="absolute"
      width="100%"
      height="100%"
      top={0}
      left={0}
      display="flex"
      justifyContent="center"
      alignItems="center"
      overflow="hidden"
    >
      <div className="spin spin--30 buy-wear-return-repeat">
        <img
          src="/images/Buy-Wear-Return-Repeat.svg"
          alt="Buy, wear, return repeat"
          style={{ height: "100%", width: "100%" }}
        />
      </div>
    </Box>
  );
}

export default BuyWearReturnRepeatAlt;
